import { render, staticRenderFns } from "./workflow-list.vue?vue&type=template&id=8286b9ec&scoped=true&"
import script from "./workflow-list.vue?vue&type=script&lang=js&"
export * from "./workflow-list.vue?vue&type=script&lang=js&"
import style0 from "./workflow-list.vue?vue&type=style&index=0&id=8286b9ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8286b9ec",
  null
  
)

export default component.exports